import { z } from "zod";
import { emailSchema } from "../common/email.js";

export const requestMagicLinkSchema = z.object({
	email: emailSchema,
});

export type RequestMagicLinkPayload = z.infer<typeof requestMagicLinkSchema>;
